<div id="actionDialog" class="modal modal-lg modal-dialog fade in" role="dialog" style="display: none;" appDraggable dragTarget="#actionDialog" dragHandle="#actionDialogHeader">
	<div class="modal-content">
		<div class="modal-header" id="actionDialogHeader">
			<button type="button" class="close" (click)="hide()"><i class="fa fa-times" aria-hidden="true"></i></button>
			<h4 *ngIf="isNew()" class="modal-title">
				<i class="fa fa-flask" aria-hidden="true"></i> CREATE REACTION
			</h4>

			<h4 *ngIf="isEdit()" class="modal-title">
				<i class="fa fa-refresh" aria-hidden="true"></i> UPDATE REACTION: {{action.name}}
			</h4>
		</div>
	
		<div class="modal-body internal-well">
			<div class="form-group" *ngIf="action != null">
				<div class="row">
					<div class="col-sm-2"><label for="name" class="labelRequired">NAME: </label></div>
					<div class="col-sm-5"><input class="form-control" type="text" [(ngModel)]="action.name" /></div>
				</div>
			</div>
			<div class="form-group" *ngIf="action != null">
				<div class="row">
					<div class="col-sm-2"><label for=description class="labelRequired">TYPE: </label></div>
					<div class="col-sm-5">
						<select class="form-control" [(ngModel)]="action.type" [ngModelOptions]="{standalone: true}">
							<option [ngValue]="null">-- Choose -- </option>
							<option *ngFor="let type of actionTypes" [ngValue]="type">
								{{type}}
							</option>
						</select>
					</div>
				</div>
			</div>
			<div class="form-group" *ngIf="action != null">
				<div class="row">
					<div class="col-sm-2"><label for=description class="labelRequired">DESCRIPTION</label></div>
					<div class="col-sm-5"><input class="form-control" type="text" [(ngModel)]="action.description" /></div>
				</div>
			</div>

			<br>
			
			<button class="btn btn-primary add-op" type="button" (click)="addProperty()">
			    <em class="fa fa-plus"></em> ADD PROPERTY
			</button>
	
		<div class="well" *ngIf="action != null && action.properties != null">
			<div class="row">
	<!-- 			<div class="col-xs-1">&nbsp;</div> -->
				<div class="col-xs-2">KEY</div>
				<div class="col-xs-3">LABEL</div>
				<div class="col-xs-3">TYPE</div>
				<div class="col-xs-3">DISPLAY</div>
				<div class="col-xs-1">&nbsp;</div>
			</div>
			<ng-container *ngFor="let property of action.properties">
				<div class="row form-group">
	<!-- 				<div class="col-xs-1">&nbsp;</div> -->
					<div class="col-xs-2">
						<input id="key" class="form-control" type="text" [(ngModel)]="property.property" />
					</div>
					<div class="col-xs-3">
						<input id="name" class="form-control" type="text" [(ngModel)]="property.name" />
					</div>
					<div class="col-xs-3">
						<select class="form-control" [(ngModel)]="property.type">
							<option *ngFor="let propertyType of getPropertyTypes()" [ngValue]="propertyType">
								{{propertyTypeService.getDisplayValueForPropertyType(propertyType)}}
							</option>
						</select>
					</div>
					<div class="col-xs-3">
						<select class="form-control" [(ngModel)]="property.parameter">
							<option *ngFor="let parameter of getParametersForPropertyType(property.type)" [ngValue]="parameter.value">
								{{parameter.displayValue}}
							</option>
						</select>
					</div>				
					<div class="col-1"><a (click)="removeProperty(property)"><em class="fa fa-minus-square fa-2x"></em></a></div>
				</div>
			</ng-container>
		</div>
		</div>

		
		<div class="modal-footer">
			<button type="button" class="btn btn-default" (click)="hide()"><i class="fa fa-ban" aria-hidden="true"></i> CANCEL</button>
			<button type="button" *ngIf="isNew()" button class="btn btn-primary" (click)="onSave()"><i class="fa fa-plus" aria-hidden="true"></i> CREATE</button>
			<button type="button" *ngIf="!isNew()" button class="btn btn-primary" (click)="onSave()"><i class="fa fa-refresh" aria-hidden="true"></i> UPDATE</button>
		</div>
	</div>
</div>
